export default [
  {
    path: '/companies',
    name: 'companies',
    component: () => import('@/views//company/list'),
  },
  {
    path: '/company/:id/:tab?',
    name: 'company',
    component: () => import('@/views/company/single'),
    meta: {
      pageTitle: 'Company',
      breadcrumb: [
        {text: 'Companies', to: {name: 'companies'}},
        {text: 'Company', active: true},
      ],
    },
    beforeEnter(to, _, next) {
      if (!to.params.tab) {
        return next({name: 'company', params: {id: to.params.id, tab: 'tasks'}})
      }

      if (!['tasks'].includes(to.params.tab)) {
        return next({name: 'error-404'})
      }

      next()
    },
  },
]
